import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SecureComponent } from './secure/secure.component';
import { DashboardComponent } from './secure/dashboard/dashboard.component';

import { PublicComponent } from './public/public.component';
import { LoginComponent } from './public/login/login.component';
import { ForgotPasswordComponent } from './public/forgot-password/forgot-password.component';
import { ResetComponent } from './public/reset/reset.component';
import { ProfiloUtenteComponent } from './secure/dashboard/profilo-utente/profilo-utente.component';
import { BachecaComponent } from './secure/dashboard/bacheca/bacheca.component';
import { IlMioTeamComponent } from './secure/dashboard/il-mio-team/il-mio-team.component';
import { StoricoTeamPassatiComponent } from './secure/dashboard/components/storico-team-passati/storico-team-passati.component';
import { CardNotificheComponent } from './secure/dashboard/components/card-notifiche/card-notifiche.component';
import { ScrumComponent } from './secure/dashboard/components/card-lista-teams/scrum/scrum.component';
import { CalendarComponent } from './secure/dashboard/components/calendar/calendar.component';
import { NewTimesheetComponent } from './secure/dashboard/new-timesheet/new-timesheet.component';
import { CalendarSmartComponent } from './secure/dashboard/components/calendar-smart/calendar-smart.component';
import { notificationGuard } from './_helpers/notification.guard';
import { authGuard } from './secure/auth.guard';
import { sectionGuard } from './secure/section.guard';

const routes: Routes = [
  {
    path: '',
    component: PublicComponent,
    children: [
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      { path: 'login', component: LoginComponent, data: { title: 'Login' } }
    ]
  },
  {
    path: 'secure',
    component: SecureComponent,
    children: [
      { path: '', redirectTo: 'dashboard/bacheca', pathMatch: 'full' },
      { path: 'dashboard', redirectTo: 'dashboard/bacheca', pathMatch: 'full' },
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [],
        children: [
          {
            path: 'profilo-utente',
            component: ProfiloUtenteComponent,
            canActivate: [notificationGuard, sectionGuard],
            data: { title: 'Profilo utente', section: 'profilo' }
          },
          {
            path: 'bacheca',
            component: BachecaComponent,
            canActivate: [notificationGuard],
            data: { title: 'Bacheca' }
          },
          {
            path: 'timesheet',
            component: NewTimesheetComponent,
            canActivate: [notificationGuard, sectionGuard],
            data: { title: 'Time sheet', section: 'time sheet' }
          },
          {
            path: 'progetti',
            component: PublicComponent,
            canActivate: [notificationGuard, sectionGuard],
            data: { title: 'I miei team', section: 'i miei team' },
            children: [
              {
                path: '',
                component: IlMioTeamComponent,
                canActivate: [notificationGuard, sectionGuard],
                data: { title: 'I miei team', section: 'i miei team' }
              },
              {
                path: ':alias/sprints',
                component: ScrumComponent,
                canActivate: [notificationGuard, sectionGuard],
                data: { title: ':alias', section: 'i miei team' }
              },
              {
                path: ':alias/sprints/:sprint_id',
                component: ScrumComponent,
                canActivate: [notificationGuard, sectionGuard],
                data: { title: ':alias', section: 'i miei team' }
              },
              {
                path: 'storico-team-passati',
                component: StoricoTeamPassatiComponent,
                canActivate: [notificationGuard, sectionGuard],
                data: { title: 'Storico team passati', section: 'i miei team' }
              }
            ]
          },
          {
            path: 'sbi',
            canActivate: [notificationGuard, sectionGuard],
            data: { title: 'SBI', section: 'sbi' },
            loadChildren: () =>
              import('./secure/dashboard/components/sbi/sbi.module').then(
                m => m.SbiModule
              )
          },
          {
            path: 'notifiche',
            component: CardNotificheComponent,
            canActivate: [notificationGuard, sectionGuard],
            data: { title: 'Notifiche', section: 'notifiche' }
          },
          {
            path: 'calendar',
            component: PublicComponent,
            canActivate: [notificationGuard, sectionGuard],
            data: { title: 'Calendario', section: 'calendario' },
            children: [
              {
                path: '',
                component: CalendarComponent,
                canActivate: [notificationGuard, sectionGuard],
                data: { title: 'Calendario', section: 'calendario' }
              },
              {
                path: 'calendario-smart',
                component: CalendarSmartComponent,
                canActivate: [sectionGuard, authGuard],
                data: {
                  title: 'Calendario smart',
                  section: 'calendario',
                  expectedRole: ['admin']
                }
              }
            ]
          },
          {
            path: 'impostazioni-admin',
            canActivate: [authGuard, notificationGuard, sectionGuard],
            data: {
              expectedRole: ['admin', 'project_manager'],
              section: 'impostazioni'
            },
            loadChildren: () =>
              import('./secure/dashboard/admin/admin.module').then(
                m => m.AdminModule
              )
          },
          {
            path: 'sondaggi',
            canActivate: [notificationGuard, sectionGuard],
            data: { title: 'Sondaggi', section: 'sondaggi' },
            loadChildren: () =>
              import('./secure/dashboard/surveys/surveys.module').then(
                m => m.SurveysModule
              )
          },
          {
            path: 'monitoraggio',
            loadChildren: () =>
              import(
                './secure/dashboard/monitoraggio/monitoraggio.module'
              ).then(m => m.MonitoraggioModule)
          },
          {
            path: 'fatturazione',
            canActivate: [notificationGuard, sectionGuard],
            data: { title: 'Fatturazione Ore', section: 'monitoraggio' },
            loadChildren: () =>
              import(
                './secure/dashboard/monitoraggio/monitoraggio-fatturazione.module'
              ).then(m => m.MonitoraggioFatturazioneModule)
          }
        ]
      }
    ]
  },
  {
    path: 'forgot-password/:token',
    component: ForgotPasswordComponent
  },
  {
    path: 'reset-password',
    component: ResetComponent
  },
  { path: '**', redirectTo: 'secure/dashboard/bacheca' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
